import { Navigate } from 'react-router-dom';
import { getStoredToken, getStoredUser } from '@/lib/api';

export default function AuthGuard({ children, role }) {
  const token = getStoredToken();
  const user = getStoredUser();
  if (!token || !user) return <Navigate to="/" replace />;
  if (role === 'admin' && user.role !== 'admin') return <Navigate to="/app/home" replace />;
  if (role === 'client' && user.role === 'admin') return <Navigate to="/coach/clients" replace />;
  if (role === 'client' && !user.onboarding_done) return <Navigate to="/onboarding" replace />;
  return children;
}
